import styled from 'styled-components'
import theme from 'styles/theme'
import { themeGet } from 'styled-system'

export const ListicleHeadline = styled.div`
  max-width: 580px;
  width: 90%;
  margin: 0 auto;
  display: block;
  position: relative;
  padding: ${theme.space[8]} 0 0;
  margin-bottom: ${theme.space[10]};

  span {
    position: absolute;
    width: 100%;
    text-align: center;
    color: ${themeGet('colors.sagelight')};
    z-index: 1;
    display: block;
    top: 0;
  }

  h4 {
    width: 100%;
    text-align: center;
    color: ${themeGet('colors.sagedark')};
    z-index: 2;
    display: block;
    position: relative;
  }
`

export default {
  ListicleHeadline,
}
